import { RefObject } from "react";
import { ArrayTail } from "type-fest";
// eslint-disable-next-line no-restricted-imports -- this replaces this particular usage since the type is not compatible with React 19
import { useOnClickOutside as originalUseOnClickOutside } from "usehooks-ts";

type OriginalParameters = Parameters<typeof originalUseOnClickOutside>;
type OriginalReturnType = ReturnType<typeof originalUseOnClickOutside>;

/**
 * This change to the original usehooks-ts type to add `null` to the
 * `RefObject` in order to make it compatible with React 19 types.
 * The implementation of `useOnClickOutside` already checks for the
 * presence of a current value of the ref, so this change to the type
 * is safe.
 *
 * See: https://github.com/juliencrn/usehooks-ts/blob/61949134144d3690fe9f521260a16c779a6d3797/packages/usehooks-ts/src/useOnClickOutside/useOnClickOutside.ts#L52
 */
type UseOnClickOutside<T extends HTMLElement = HTMLElement> = (
  ...args: [
    RefObject<T | null> | RefObject<T | null>[],
    ...ArrayTail<OriginalParameters>,
  ]
) => OriginalReturnType;

export const useOnClickOutside = originalUseOnClickOutside as UseOnClickOutside;
